import React from 'react'
import './AllTransactionsComponent.css'
const AllTransactionsComponent = () => {
  return (
    <div className="banner_section" style={{ flex: "1" }}>
      AllTransactionsComponent
    </div>
  )
}

export default AllTransactionsComponent
